import comp from "./OrganizationResourcesSelection";
export default comp;
